
  import Alpine from 'alpinejs';
  import { changeCoverToSingle } from "../../_svelte/api/changeCoverToSingle";

  // initialize alpine
  window.Alpine = Alpine;

  const urlParams = new URLSearchParams(window.location.search);
  const travelId = urlParams.has('id') && urlParams.get('id');

  // build the config object for the api Requests
  let apiRequestConfig = {
    travelId: travelId,
    apis: {
      auth: {
        subscriptionKey: 'E0B293EA-5CD0-E711-80D7-00155DD475CE',
        clientId: 'ordering-flow-a1srb',
        clientSecret: 'C6EMmSEwwbm6MgrmsBX7QjrlyKKZCFeM',
      },
      methods: {
        accessToken: 'https://lamie.systems/auth/realms/core/protocol/openid-connect/token',
        changeCover: 'https://lamie.systems/travel/api/v1/travels/changecover'
      }
    },
    contractType: 'Travel_Insurance_A1_SRB_Single'
  }

  document.addEventListener('alpine:init', () => {
    Alpine.data('request', () => ({
      success: false,
      error: null,
      disabled: false,
      loading: false,
      init() {
        if (!travelId) {
          this.error = 'No travel ID provided';
          this.disabled = true;
          return;
        }
      },
      async submit() {
        this.disabled = true;
        this.loading = true;

        changeCoverToSingle(apiRequestConfig).then(response => {
          this.disabled = false;
          this.loading = false;
          this.error = null;

          if (response.status === 'error') {
            console.error('Change cover error:', response);
            if (response.code === 422) {
              this.error = 'Istekao je period za promenu pokrića Pametnog putnog osiguranja. Promenu pokrića sa Grupnog na Individualno više nije moguće izvršiti.';
              this.disabled = true;
            } else {
              this.error = 'Došlo je do greške pri pokušaju promene pokrića Pametnog putnog osiguranja.';
            }
          } else {
            this.success = true;
          }
        });
      }
    }))
  });

  Alpine.start();
